import { useCallback } from "react"
import { getUserBids } from '../../sushi/utils'
import { getUserBidsByNFT } from '../../sushi/exchangeNFTs'
import { userBidNFTContract } from '../../userType/userBidNFTContract'
import { useActiveWeb3React } from '../'
import useYam from "../bakery/useYam"

import { MARKETTYPE, MARKETMULTITOKEN, MARKETTYPEV1, MARKETTYPEV3 } from '../../constants/bakery/nft'
import { multiTokenExchangeNftContract } from '../../userType/multiTokenExchangeNftContract'
import { userNftTypeNum } from '../../userType/userNftTypeNum'

import { userNftAddress } from '../../userType/userNftAddress'
import { userExchangeNFTContract } from "../../userType/userExchangeNFTContract"
import { userV3NFTContract } from "../../userType/userV3NFTContract"

const useUserBids = (type?: string, owner?: string) => {
  const sushi = useYam()
  const { account } = useActiveWeb3React()
  // const account = "0x4f0ba7de64e031b79e681f2ce76b12bb22d7046d"

  const typeArray = type?.split(",")
  const exchangeNFTContractArray: any = typeArray?.map((d:any) => {
    let exchangeNFTContract: any
    let isMultiToken:boolean = false
    if(d && MARKETTYPE.hasOwnProperty(d)){
      exchangeNFTContract = userBidNFTContract(sushi, d)
      isMultiToken = false
    }else if(d && MARKETMULTITOKEN.hasOwnProperty(d)){
      exchangeNFTContract = multiTokenExchangeNftContract(sushi, d)
      isMultiToken = true
    }else if(d && MARKETTYPEV1.hasOwnProperty(d)){
      exchangeNFTContract = userExchangeNFTContract(sushi, d)
    }else if(d && MARKETTYPEV3.hasOwnProperty(d)){
      exchangeNFTContract = userV3NFTContract(sushi, d)
      isMultiToken = true
    }
    return {
      exchangeNFTContract: exchangeNFTContract,
      isMultiToken: isMultiToken,
      type: d
    }
  })

  // let exchangeNFTContract: any
  // let isMultiToken:boolean = false

  // if(type && MARKETTYPE.hasOwnProperty(type)){
  //   exchangeNFTContract = userBidNFTContract(sushi, type)
  //   isMultiToken = false
  // }else if(type && MARKETMULTITOKEN.hasOwnProperty(type)){
  //   exchangeNFTContract = multiTokenExchangeNftContract(sushi, type)
  //   isMultiToken = true
  // }else if(type && MARKETTYPEV1.hasOwnProperty(type)){
  //   exchangeNFTContract = userExchangeNFTContract(sushi, type)
  // }else if(type && MARKETTYPEV3.hasOwnProperty(type)){
  //   exchangeNFTContract = userV3NFTContract(sushi, type)
  //   isMultiToken = true
  // }

  const userBids = useCallback(async() => {
    try {
      let userBidsMultiType: any[] = []
      for(let i = 0;i < exchangeNFTContractArray.length;i++){
        let userBids: any[] = []
        if(!exchangeNFTContractArray[i].isMultiToken) {
          if (owner) {
            userBids = await getUserBids(exchangeNFTContractArray[i].exchangeNFTContract, owner)
          } else {
            userBids = await getUserBids(exchangeNFTContractArray[i].exchangeNFTContract, account)
          }
        }else {
          if(exchangeNFTContractArray[i].type && MARKETMULTITOKEN.hasOwnProperty(exchangeNFTContractArray[i].type) || (exchangeNFTContractArray[i].type && MARKETTYPEV3.hasOwnProperty(exchangeNFTContractArray[i].type))){
            let nftAddress = userNftAddress(sushi, exchangeNFTContractArray[i].type)
            let nftType = userNftTypeNum(exchangeNFTContractArray[i].type)
            if (owner) {
              let curTokenBids = await getUserBidsByNFT(exchangeNFTContractArray[i].exchangeNFTContract, nftAddress, owner)
              userBids = curTokenBids.map((d: any) => {
                return [
                  d.tokenId,
                  d.price,
                  d.quote,
                  nftType
                ]
              })
            } else {
              let curTokenBids = await getUserBidsByNFT(exchangeNFTContractArray[i].exchangeNFTContract, nftAddress, account)
              userBids = curTokenBids.map((d: any) => {
                return [
                  d.tokenId,
                  d.price,
                  d.quote,
                  nftType
                ]
              })
            }
          }
        }
        userBidsMultiType = [...userBidsMultiType, ...userBids]
      }
      
      // console.log("--userBidsMultiType--,",userBidsMultiType)
      const list = userBidsMultiType.map((d: any) => {
        return {
          ...d,
          type: 'BID'
        }
      })
      return list
    } catch (e) {
      return []
    }
  }, [account, exchangeNFTContractArray, owner, sushi, type])
  return userBids
}

export default useUserBids